import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/core'
import { genUID } from '@entrata/utils'

const st0 = css`
  fill: #e2edf6;
`
const st1 = css`
  fill: #e4d6de;
`
const st2 = css`
  fill: #fcdcce;
`
const st3 = css`
  fill: #eadcd5;
`
const st4 = css`
  fill: #ffffff;
`
const st5 = css`
  fill: #273e4f;
`
class GiveUsReview extends React.Component {
  constructor(props) {
    super(props)
    this.titleId = genUID()
  }

  render() {
    const {
      style = {},
      size = 16,
      height,
      width,
      svgRef,
      title,
      ...props
    } = this.props

    return (
      <svg
        viewBox='0 0 104 104'
        height={height || size}
        width={width || size}
        ref={svgRef}
        aria-labelledby={title ? this.titleId : undefined}
        style={{
          pointerEvents: 'none',
          fill: 'currentColor',
          ...style,
        }}
        {...props}
      >
        {title ? <title id={this.titleId}>{title}</title> : null}
        <path css={st0} d='M98.4,53.8h-47V42.2l-9.5-1.8l9.5-7.9V2.5h47V53.8z' />
        <path
          css={st1}
          d='M40.2,97.8h-38V65.4c0-13.3,8.5-17,19-17c9.9,0,19,3,19,17V97.8z'
        />
        <path
          css={st2}
          d='M71.1,9.8c3.1-1.3,5.5,9.1,5.5,9.1s8.3-2.5,10.4,0c2.1,2.5,1.6,17.6,0,19.2c-1.6,1.5-11.5,2.4-15.1,1.3 c-3.6-1.1-3.5-2.8-3.5-2.8l0-13.6C68.4,22.9,69,10.6,71.1,9.8z M28.7,20.6c-2-0.8-4.8,1-7.4,1c-2.9,0-6.2-1-8.3,0 c-2.9,1.4-4.2,5.3-4.2,9.3c0,5.3,3.3,9.8,7.9,11.7c1.4,0.6-0.9,11.2,4.6,11.2c5.4,0,3-10.6,4.3-11.1c4.9-1.7,8.3-6.4,8.3-11.8 C33.9,26.6,32.1,21.9,28.7,20.6z M31.1,97.8h8V73.6l-8,4.3V97.8z M11.5,77.8l-8-4.3v24.2h8V77.8z'
        />
        <path
          css={st3}
          d='M7,29.7c0,0-3.5-7.6,1.7-12.4s5.2-7.2,11.5-7.6c6.3-0.4,12.2-1.2,13.6,1.3c1.4,2.5,2.8,8.5,2.8,8.5 s2.5,6.6-1.6,10.3c0,0,1.1-9.7-7.5-9.3S20,21.7,15,20.4S7,29.7,7,29.7z'
        />
        <path css={st4} d='M68.4,40.4h-7.7V21.6h7.7V40.4z' />
        <path
          css={st5}
          d='M22.9,33.1c0.3-0.2,0.6-0.9,0.5-1.1c-0.2-0.2-4-0.2-4.2,0c-0.2,0.1-0.1,0.9,0.3,1.1 C19.8,33.3,22.5,33.3,22.9,33.1z M25.5,29.7c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2C23.5,28.8,24.4,29.7,25.5,29.7z M31.1,48.4c-0.8-0.1-2-0.7-3.3-1.3v-2.9c4.6-2.2,7.8-6.7,8.3-12c0,0,0,0,0,0c0.2-0.2,5-4.5,3.9-10.1c-0.7-3.3-2.1-4.4-3.3-4.8 c0.3-1.8,0.2-4-0.7-6.5C35.4,9,34.2,8.3,33.3,8c-5.2-0.6-3.7,1.2-10.3-0.1c-3.5-0.7-8.9,1.4-11.4,3.6c-2,1.9-3.2,3.4-3.6,4.2 c-1.7,0.5-3.5,2.2-4.4,6.7c-0.9,4.5,1.6,7.9,2.8,9.2c0.3,5.5,3.6,10.3,8.3,12.6V47c-1.2,0.6-2.6,1.2-3.3,1.3C4.9,49.5,0,55,0,61.1 l1,37.2c0,0.9,0.8,1.7,1.7,1.7h37.1c0.9,0,1.7-0.8,1.7-1.7l1-37.2C42.6,55,37.6,49.5,31.1,48.4z M35.7,20.6c0,0,0.5,0.3,0.8,2.1 c0.2,1.1,0.1,2.2-0.3,3.1c-0.4-1.2-1.1-2.4-2.3-3.7C34.5,21.5,35.4,20.6,35.7,20.6z M13.8,13.7c1.7-1.1,5.3-3.2,8.9-2.7 c7.3,1.1,8.9-1.3,10.1,0.9c1.3,3.6,0.4,5.7-0.2,6.5c-0.5,0.7-1.2,1.1-1.5,1.1c-2.8-2.6-5-1.6-7-0.6c-0.8,0.4-3.4,1.2-4,1.3 c-4.4,0.4-5.6-0.9-6.9-1.8C11.9,17.7,10.3,16.1,13.8,13.7z M7.1,23c0.5-2.4,1.3-4,2.2-4.1c0.7-0.1,1.3,0.4,1.8,0.9 c-1.6,1.9-3.6,7.1-3.7,7.2C7.1,26,6.9,24.2,7.1,23z M9.9,31c0-1.8,1-5.5,3.7-8.7c0,0,1.9,1.3,5.5,1.4c3.6,0.1,7.8-3.8,10.3-0.8 c2,2.3,3.3,5,3.3,8.1c0,6.3-5.1,11.4-11.4,11.4C15.1,42.2,10,37.2,9.9,31z M21.3,51.3c-3.2,0-3.2-3.6-3-5.9c0,0,1.5,0.3,3,0.3 c1.5,0,2.9-0.3,3-0.3C24.4,47.7,24.5,51.4,21.3,51.3z M10,96.5H4.5L3.9,75.9l6,3.1c0,0,0.1,0,0.1,0V96.5z M38.1,96.5h-5.5V78.9 l6.1-3.1L38.1,96.5z M38.8,71.8C38.7,71.8,38.7,71.8,38.8,71.8L32.6,75V60.7c0-1-0.8-1.8-1.8-1.8s-1.8,0.8-1.8,1.8v35.8H13.5V60.7 c0-1-0.8-1.8-1.8-1.8S10,59.8,10,60.7v14.4L3.8,72L3.5,61.1c0-4.4,3.7-8.4,8.6-9.3c0.9-0.2,2-0.6,3.2-1.1c1,2.4,3.3,4.1,6.1,4.1 c2.7,0,5.1-1.7,6.1-4.1c1.2,0.5,2.2,0.9,3.2,1.1c4.9,0.8,8.5,4.8,8.5,9.2L38.8,71.8z M17,29.7c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2 c-1.1,0-2,0.9-2,2C15,28.8,15.9,29.7,17,29.7z M27.1,35H15.4c0,1.7,3.4,3,5,3h1.6C23.8,38.1,27.1,36.7,27.1,35z M90.3,20 c-0.7-3.3-5.1-3.9-7-3.7c-1.3,0.1-5.2,1.2-5.2,1.2c0-1.6-0.2-3.7-0.7-5.4c-0.7-2.2-2.8-4-4.9-4.3c-1.7-0.2-3.2,0.6-4.1,2.2 c-0.6,1-0.5,2.4-0.4,4.2c0,0.7,0.1,1.5,0,2.1c0,1.1-0.3,2.5-0.5,3.8h-6.6c-1,0-1.8,0.8-1.8,1.8v18.3c0,1,0.8,1.8,1.8,1.8h7.6 c0.9,0,1.6-0.6,1.7-1.5c2.6,0.6,6.9,1.5,9.6,1.5c3.2,0,7.2-1.1,8.7-4c0.5-0.9,1.2-2.8,1.3-4.1c0.1-1.5-0.6-2.6-0.5-3.7 c0.1-1.2,0.8-2.3,0.9-3.8c0.1-1.7-0.6-2-0.4-3C89.8,22.2,90.6,21.3,90.3,20z M66.7,38.3h-4.1V23.5h4.1V38.3z M86.7,26.5 c-0.1,1.5-0.9,1.9-1,3.5c-0.1,1.1,0.8,3.3,0.4,4.9c-0.6,2.1-3.9,3.2-5.7,3.5c-2.8,0.3-6.7-0.7-10.2-1.6V23.3c1.2-2.8,1.2-6.9,1.2-7 c0.1-1.4-0.2-3.6,0-4.8c0.6-1,2.3,0.4,2.6,1.5c0.8,2.5,0.6,6.5,0.6,6.5c-0.1,1.1,1.1,2.1,2.2,1.8c0,0,5-1.5,6.7-1.6 c1.4-0.1,3.1,0,3.5,1c0.4,1.2-0.4,1.7-0.5,2.8C86.3,24.6,86.8,25.4,86.7,26.5z M98.2,0H51.1c-1,0-1.8,0.8-1.8,1.8v30.8l-10.1,6.9 c-0.6,0.4-0.9,1.2-0.7,1.9c0.2,0.7,0.9,1.2,1.6,1.3l9.2,0.4v10.9c0,1,0.8,1.8,1.8,1.8h47.1c1,0,1.8-0.8,1.8-1.8V1.8 C100,0.8,99.2,0,98.2,0z M96.5,51.1c0,0.6-0.4,1-1,1H53.9c-0.6,0-1-0.4-1-1v-9.9c0-0.9-0.7-1.7-1.7-1.7l-5.6-0.2l6.5-4.4 c0.5-0.3,0.8-0.9,0.8-1.4V4.5c0-0.6,0.4-1,1-1h41.6c0.6,0,1,0.4,1,1V51.1z M66.1,35c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5 s0.7-1.5,1.5-1.5C65.5,33.5,66.1,34.2,66.1,35z'
        />
      </svg>
    )
  }
}

GiveUsReview.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  svgRef: PropTypes.func,
  style: PropTypes.object,
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
export { GiveUsReview }
